import { createSlice } from '@reduxjs/toolkit';

const loaderSlice = createSlice({
  name: 'loader',
  initialState: { count: 0 },
  reducers: {
    stepUpLoaderCount: (state) => {
      state.count += 1;
    },
    stepDownLoaderCount: (state) => {
      state.count = Math?.max(0, state?.count - 1);
    },
  },
});

export const { stepUpLoaderCount, stepDownLoaderCount } = loaderSlice.actions;
export default loaderSlice.reducer;
